import { combineReducers } from 'redux';

import {
  initOrganizationRequest,
  initOrganizationSuccess,
  initOrganizationFail, initOrganizationClear,
} from '../actions';
import { OrganizationAction, StateOrganization } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof StateOrganization> = Reducer<StateOrganization, OrganizationAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {

    case initOrganizationRequest.type:
    case initOrganizationClear.type:
      return null;

    case initOrganizationSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case initOrganizationRequest.type:
      return true;

    case initOrganizationSuccess.type:
    case initOrganizationFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateOrganization>({
  data,
  loading,
});
